<style lang="less" scoped>
.info-window-div{
    width:17.3125rem /* 277/16 */;
    height:15rem /* 233/16 */;
    background:rgba(255,255,255,1);
    box-shadow:0rem -.5rem 1rem 0rem rgba(42,42,68,0.1);
    border-radius:1.25rem;
    opacity:0.89;
}
.img{
    width:15.9375rem /* 255/16 */;
    height:8.625rem /* 138/16 */;
    border-radius:1.25rem /* 20/16 */;
    margin:0rem .6875rem .375rem .6875rem;
}
.charge-status{
    height:1.0625rem /* 17/16 */;
    font-size:.75rem /* 12/16 */;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:1.0625rem /* 17/16 */;
    margin:0rem 0rem .3rem .6875rem /* 11/16 */;
}
.fee{
    height:1.0625rem /* 17/16 */;
    font-size:.75rem /* 12/16 */;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(183,128,243,1);
    line-height:1.0625rem /* 17/16 */;
    margin-left:5.1875rem /* 83/16 */;
}
.station-name{
    height:1.25rem /* 20/16 */;
    font-size:.875rem /* 14/16 */;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
    color:rgba(0,0,0,1);
    line-height:1.25rem /* 20/16 */;
    margin:0rem 0rem .3rem .6875rem /* 11/16 */;
    cursor: pointer;
}
.all-charge-val{
    height:1.0625rem /* 17/16 */;
    font-size:.75rem /* 12/16 */;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:1.0625rem /* 17/16 */;
    margin:0rem 0rem .3rem .6875rem /* 11/16 */;
}
.info-close-icon{
    cursor: pointer;
    float:right;
    // overflow: hidden;
    margin:.3rem .65rem 0rem 0rem;
}
</style>
<template>
    <div class="info-window-div">
        <i class="el-icon-close info-close-icon" @click="closeInfo"></i>
        <el-image class="img" :src="stationInfo.imgUrl" :preview-src-list="srcList"></el-image>
        <div class="flex">
            <div class="charge-status">充电状态 {{stationInfo.stationStatusName}}</div>
            <div class="fee">{{stationInfo.chargeAmt}}元/KWH</div>
        </div>
        <el-tooltip v-if="flag" class="item" effect="dark" :content="stationName" placement="top-start">
            <div class="station-name" @click="toStationDetail()">{{shortStationName}}</div>
        </el-tooltip>
        <div v-else class="station-name" @click="toStationDetail()">{{stationInfo.stationName}}</div>
        <div class='all-charge-val'>累计充电量 {{stationInfo.totalChargeCount}} KWH</div>
    </div>
</template>
<script>
export default {
        data() {
            return {
                stationInfo:{},
                srcList:["https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"],
                flag:false,
                stationName:'',
                shortStationName:'',
            }
        },
        methods: {
            init(val){
                this.stationInfo = val;
                this.srcList.push(this.stationInfo.imgUrl);
                this.stationName = this.stationInfo.stationName;
                if(this.stationInfo.stationName.length > 17){
                    this.shortStationName = this.stationInfo.stationName.substring(0,15) + "..."
                    this.flag = true;
                }else{
                    this.flag = false;
                }
                if(!this.stationInfo.totalChargeCount){
                    this.stationInfo.totalChargeCount = 0
                }
            },
            toStationDetail(){
                let _ = this;
                if(_.stationInfo.enableStatus == 'Y'){
                    var url = _.$router.resolve({name: 'pileStationDetail',query: {id: _.stationInfo.id}})
                    window.open(url.href,'_blank')
                }
                if(_.stationInfo.enableStatus == 'N'){
                    var url = _.$router.resolve({name: 'reportDetail',query: {id: _.stationInfo.id,stationNo: _.stationInfo.stationNo}})
                    window.open(url.href,'_blank')
                }
            },
            closeInfo(){
                this.$emit('close-info-window','close')
            }
        },
        mounted() {
            this.$on('update', this.init)
        },
        destroyed() {
            this.$off('update', this.init)
        },
    }
</script>